export const cibWebcomponentsOrg = ["32 32","<path d='M15.641 2.969l-0.016 0.021h-8.135l-7.49 12.984 7.49 12.979h17.063l0.057 0.078 2.844-4.979 0.693-1.188h-0.010l0.010-0.021-0.839-1h1.198l0.005-0.016 0.010 0.016 3.474-5.854-3.474-5.849-0.005 0.005-0.010-0.026h-1.26l0.839-1.021-3.474-6.089-0.010 0.010-0.031-0.052zM12.141 9.099h8.255l-0.708 1.021h-0.031l3.198 5.349h1.167l-0.37 0.438 0.474 0.583h-1.271l-3.198 5.354h0.036l0.693 1.016h-8.286l-3.99-6.891 4.031-6.875z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-webcomponents-org.js
// module id = null
// module chunks = 